import { FilePreview, Typography, Dropzone, Button } from '@ui/components';
import { ComponentPropsWithoutRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Success } from '@ui/components/icons';

type FileUploaderProps = {
  fileChange: (file: File | null) => void;
  errorMessage?: string | null;
  isPending?: boolean;
  file: File | null;
} & Partial<ComponentPropsWithoutRef<typeof Dropzone>>;

export const FileUploader: FC<FileUploaderProps> = ({
  errorMessage,
  fileChange,
  className,
  isPending,
  file,
}) => {
  const { t } = useTranslation();

  if (file && !isPending) {
    return (
      <>
        <FilePreview
          actions={
            <Button onClick={() => fileChange(null)} variant="secondary" size="small">
              {t('EMPLOYEES.MASS_IMPORT.UPLOADER.REPLACE_FILE')}
            </Button>
          }
          file={file}
        />
        <div className="text-success flex items-center gap-2 pl-4 mt-8 h-8">
          <Success className="size-4" />
          <Typography variant="h100">
            {t('EMPLOYEES.MASS_IMPORT.UPLOADER.FILE_LOADED_SUCCESSFULLY')}
          </Typography>
        </div>
      </>
    );
  }

  return (
    <Dropzone
      multipleFilesUploadedErrorMessage={t(
        'EMPLOYEES.MASS_IMPORT.UPLOADER.MULTIPLE_FILES_UPLOADED_ERROR_MESSAGE',
      )}
      invalidFileFormatMessage={t('EMPLOYEES.MASS_IMPORT.UPLOADER.INVALID_FILE_FORMAT_MESSAGE')}
      fileTooLargeMessage={t('EMPLOYEES.MASS_IMPORT.UPLOADER.FILE_TOO_LARGE_MESSAGE')}
      loadingDescription={t('EMPLOYEES.MASS_IMPORT.UPLOADER.LOADING_DESCRIPTION')}
      uploadDescription={t('EMPLOYEES.MASS_IMPORT.UPLOADER.OR_DRAG_AND_DROP')}
      uploadLabel={t('EMPLOYEES.MASS_IMPORT.UPLOADER.CLICK_TO_UPLOAD')}
      loadingLabel={t('EMPLOYEES.MASS_IMPORT.UPLOADER.LOADING_LABEL')}
      errorLabel={t('EMPLOYEES.MASS_IMPORT.UPLOADER.ERROR_TITLE')}
      acceptedFormats={['csv', 'CSV']}
      errorMessage={errorMessage}
      onFileSelect={fileChange}
      isLoading={isPending}
      className={className}
      maxSizeMB={10}
      size="large"
    />
  );
};
